import { paramCase } from 'change-case';
import { FundType } from '../models/configuration/FundType';

export function getFundTypeId(fundTypeConfig: FundType): string {
    return paramCase(fundTypeConfig.id || fundTypeConfig.fundType);
}



// WEBPACK FOOTER //
// ./src/utils/getFundTypeId.ts